import React from 'react'
import HeroSection from '../components/HeroSection'
import Projects from '../components/Projects'

const Home = () => {
  return (
    <div className="sections">
      <HeroSection />
      <Projects />
    </div>
  )
}

export default Home
